import { Outlet, useLocation } from "react-router-dom";
import SideNavbar from "../components/Layout/SideNavbar";
import TopNavbar from "../components/Layout/TopNavbar";
import { useEffect, useState, useCallback, useMemo } from "react";
import { roles } from "../constants/commonConstants";
import { useSelector } from "react-redux";

const Root = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [title, setTitle] = useState("");
  const { role } = useSelector((state) => state.auth);
  const location = useLocation();

  const stableSetTitle = useCallback((newTitle) => {
    setTitle(newTitle);
  }, []);

  useEffect(() => {
    console.log('Root - setTitle function created:', typeof stableSetTitle);
    console.log('Root - current title:', title);
  }, [title, stableSetTitle]);

  const contextValue = useMemo(() => {
    const context = { setTitle: stableSetTitle };
    console.log('Root - Creating context value:', context);
    return context;
  }, [stableSetTitle]);

  return (
    <div className="min-h-screen w-full bg-[#101216] bg-black-blue-radial bg-fixed bg-no-repeat bg-cover text-white">
      <div className="flex flex-1 overflow-hidden">
        <SideNavbar setTitle={stableSetTitle} />

        <main className="flex-1 overflow-y-auto sm:ml-[268px] md:ml-[288px] lg:ml-[298px] xl:ml-[300px] mx-auto">
          <TopNavbar title={title} />
          <Outlet context={contextValue} />
        </main>
      </div>
    </div>
  );
};

export default Root;